'use strict';

var index = require('./base_index');

index.plot = require('./plot');

module.exports = index;
